import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';
import { TransportCreationProfileSight } from '../../cep-tablet.model';

@Component({
  selector: 'app-cep-profile-tile',
  templateUrl: './cep-profile-tile.component.html',
  styleUrls: ['./cep-profile-tile.component.scss']
})
export class CEPProfileTileComponent {

  @Input()
  profile: TransportCreationProfileSight;


}
